(function(angular){
	'use strict';

	var ackListTemplate = 
	'<div ' +
		'ng-repeat="acknowledgment in acknowledgmentList.formattedAcks" ' +
		'ng-form="acknowledgmentFieldForm" ' +
		'class="radio-checkbox-item"> ' +
		'<label> ' +
			'<input ' +
				'name="acknowledgment" ' +
				'type="checkbox" ' +
				'required="true" ' +
				'ng-model="acknowledgment.selected" /> ' +
			'<span class="mask"></span> ' +
			'<span ng-bind-html="acknowledgment.text | sanitize"></span> ' +
		'</label> ' +
		'<div ' +
			'class="field__error-messages" ' +
			'ng-show="acknowledgmentFieldForm.$error.required && acknowledgmentFieldForm.$$parentForm.$submitted"> ' +
			'<p class="error-message"> ' +
				'This field is required. ' +
			'</p>' +
		'</div>' +
	'</div>';
	
	var acknowledgmentListObject = {
		template: ackListTemplate,
		bindings: {
			acknowledgments: '<',
			formattedAcks: '=?'
		},
		controller: [AcknowledgmentFunction],
		controllerAs: 'acknowledgmentList'
	};
	
	angular
		.module('agreementsModule')
		.component('acknowledgmentList', acknowledgmentListObject);
	
	function AcknowledgmentFunction(){
		var acknowledgmentList = this;

		function formatList() {
			acknowledgmentList.formattedAcks = [];
				
			angular.forEach(acknowledgmentList.acknowledgments, function(acknowledgment, index) {
				acknowledgmentList.formattedAcks.push({
					id: index,
					text: acknowledgment,
					selected: false
				});
			});
		}

		acknowledgmentList.$onInit = function() {
			formatList();
		};

		acknowledgmentList.$onChanges = function() {
			formatList();
		};
	}
})(window.angular);